import { maxBy } from 'lodash';
import { Declaration, DeclarationHistory } from 'store/declarations/declaration';

/**
 * The declaration as its latest submission sent it. Customs names a rejected item by its position in
 * that submission, so this copy is what the positions are read against - the declaration today may
 * have lost items since, which moves the ones after them up.
 *
 * The history is kept in one slot of the store, so it can still hold another declaration's entries -
 * those are not this declaration's submissions.
 */
const getLatestSubmittedDeclaration = (
    history: DeclarationHistory[] | undefined,
    declarationId: string | undefined
): Declaration | undefined => {
    // A rejection answers a submission, so an amendment is no copy of what customs counted in. The
    // history only records a submission customs accepted for processing - one refused on the spot
    // leaves no entry behind.
    const submissions = (history ?? []).filter(
        (entry) => entry.type === 'SUBMIT' && entry.declarationId === declarationId
    );

    // The newest by date, whatever order the entries came in. While a resubmission is still waiting
    // for its answer the declaration is not rejected, so the newest one is always the one answered.
    return maxBy(submissions, (entry) => new Date(entry.createdAt).getTime())?.declaration;
};

export default getLatestSubmittedDeclaration;
